/* eslint-disable no-undef */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React from 'react';
import VM from '@peiyou/scratch-vm';
import bindAll from 'lodash.bindall';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import FirstStep from './first-step.jsx';
import SecondStep from './second-step.jsx';
import MediaModal from './media-modal.jsx';
import DeviceDetection from './device-detection.jsx';
import swal from '../../lib/swal';
import swal2 from '../../lib/swal2';
import {
    queryParams,
    getCityCode,
    getUserinfo
} from '../../lib/services/query-params';
import {
    shareProj,
    shareVideoPro,
    communityPublish,
    videoPointUpLimit,
    textCheck,
    videoCheck
} from '../../lib/services/scratch-ser';
import axiosLib from 'axios';
import UploadVideo from './upload-video.jsx';
import {scratchView} from '../../utils/xes-analytice';

class ShareModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'resetShareStatus',
            'handleShareProj',
            'handleNextStep',
            'handleShare',
            'handleStep',
            'handleSecondStep',
            'handleUploadError',
            'handleRecord',
            'publishCommunity',
            'handleRetryPublishCommunity',
            'handleSaveTab'
        ]);
        this.state = {
            thumbnail: null,
            selectedTab: '项目分享',
            // eslint-disable-next-line react/prop-types
            shareStatus: this.props.shareStatus || 'init',
            shareId: '',
            payload: {},
            cityCode: getCityCode(),
            videoId: '',
            publishState: '',
            isVideoPointUpLimit: false,
            singleVideoPoint: 20,
            // 视频审核状态：1 未审核，2 审核中，3 通过，4 不通过，5 重复提交
            videoCheckStatus: null,
            // 保存重新上传时的项目名称和描述
            savedProjectTitle: '',
            savedProjectDesc: ''
        };
        this.shareParams = {};
        this.shareParamsForShareProj = {};
        // 用于取消请求的 CancelToken 源
        this.cancelTokens = [];
        this.pollVideoCheckCancel = null; // pollVideoCheck 的取消函数
    }
    
    componentWillMount () {
        this.props.vm.renderer.requestSnapshot(dataURI => {
            this.setState({
                thumbnail: dataURI
            });
        });
        videoPointUpLimit().then(res => {
            if (res && res.status === 200) {
                const data = res.data.data;
                this.setState({
                    isVideoPointUpLimit: data.isVideoPointUpLimit,
                    singleVideoPoint: data.singleVideoPoint
                });
            }
        });
    }

    componentWillUnmount () {
        this.cancelAllRequests();
    }

    pollVideoCheck (params) {
        return new Promise(resolve => {
            let timer = null;
            let timeoutTimer = null;
            let isResolved = false;
            const TIMEOUT = 60000; // 60秒超时
            const videoCheckCancelTokens = []; // 保存所有 videoCheck 请求的 cancelToken
            
            // 创建取消函数
            const cancel = () => {
                if (!isResolved) {
                    isResolved = true;
                    // 取消所有进行中的 videoCheck 请求
                    videoCheckCancelTokens.forEach(cancelFn => {
                        try {
                            cancelFn('用户取消操作');
                        } catch (error) {
                    
                        }
                    });
                    videoCheckCancelTokens.length = 0;
                    clear();
                    resolve({passed: false, failed: true, cancelled: true});
                }
            };
            
            this.pollVideoCheckCancel = cancel;
            
            const clear = () => {
                if (timer) {
                    clearInterval(timer);
                    timer = null;
                }
                if (timeoutTimer) {
                    clearTimeout(timeoutTimer);
                    timeoutTimer = null;
                }
            };
            
            const resolveOnce = (result) => {
                if (!isResolved) {
                    isResolved = true;
                    clear();
                    this.pollVideoCheckCancel = null;
                    videoCheckCancelTokens.length = 0;
                    resolve(result);
                }
            };
            
            // 设置超时定时器
            timeoutTimer = setTimeout(() => {
                if (!isResolved) {
                    // 超时则认为不再处于“审核中”状态
                    this.setState({
                        videoCheckStatus: 0
                    });
                    console.error('视频内容审核超时（超过60秒）');
                    swal2.toast('审核失败，请重新上传作品');
                    resolveOnce({passed: false, failed: true});
                }
            }, TIMEOUT);
            
            const checkOnce = async () => {
                // 如果已经取消，不再发起新请求
                if (isResolved) return;
                
                // 为本次请求创建 cancelToken
                const cancelToken = axiosLib.CancelToken.source();
                videoCheckCancelTokens.push(cancelToken.cancel);
                
                try {
                    const res = await videoCheck(params, cancelToken.token);
                    if (isResolved) return;
                    
                    const index = videoCheckCancelTokens.indexOf(cancelToken.cancel);
                    if (index > -1) {
                        videoCheckCancelTokens.splice(index, 1);
                    }
                    
                    const status = res && res.data && res.data.data && res.data.data.status;
                    this.setState({
                        videoCheckStatus: status
                    });
                    // 1：未审核, 2:审核中， 3：审核通过 4：审核不通过 5: 重复提交
                    if (status === 3) {
                        resolveOnce({passed: true, failed: false});
                    } else if (status === 4) {
                        resolveOnce({passed: false, failed: true});
                    }
                } catch (error) {
                    // 如果请求被取消，不处理错误
                    if (axiosLib.isCancel && axiosLib.isCancel(error)) {
                        return;
                    }
                    if (!isResolved) {
                        console.error('视频内容审核失败:', error);
                        resolveOnce({passed: false, failed: true});
                    }
                }
            };
            // 立即检查一次
            checkOnce();
            // 之后每 3s 轮询一次
            timer = setInterval(() => {
                if (!isResolved) {
                    checkOnce();
                } else {
                    clear();
                }
            }, 3000);
        });
    }

    async handleStep (payload) {
        this.cancelTokens.forEach(cancel => {
            try {
                cancel('开始新的审核请求');
            } catch (error) {
            }
        });
        this.cancelTokens = [];
        
        // eslint-disable-next-line react/prop-types
        const {blob} = this.props;
        if (blob) {
            const {shareTitle, shareDes} = payload;
            const projectName = shareTitle || '';
            const projectDesc = shareDes || '';

            const nameCancelToken = axiosLib.CancelToken.source();
            const descCancelToken = axiosLib.CancelToken.source();
            this.cancelTokens.push(nameCancelToken.cancel, descCancelToken.cancel);

            // 文本内容审核（项目名称 & 项目描述）
            let nameFailed = false;
            let descFailed = false;

            try {
                const [nameCheckResult, descCheckResult] = await Promise.all([
                    textCheck({url: projectName, module: 6}, nameCancelToken.token),
                    textCheck({url: projectDesc, module: 6}, descCancelToken.token)
                ]);
                console.log('nameCheckResult:', nameCheckResult);
                console.log('descCheckResult:', descCheckResult);

                const nameStatus = nameCheckResult && nameCheckResult.data && nameCheckResult.data.data && nameCheckResult.data.data.status;
                const descStatus = descCheckResult && descCheckResult.data && descCheckResult.data.data && descCheckResult.data.data.status;

                nameFailed = nameStatus === 4;
                descFailed = descStatus === 4;

                // 文本检查失败，直接返回
                if (nameFailed || descFailed) {
                    let toastMessage = '';
                    if (nameFailed && descFailed) {
                        toastMessage = '项目名称和描述不符合平台的发布规范，请修改后重新上传';
                    } else if (nameFailed) {
                        toastMessage = '项目名称不符合平台的发布规范，请修改后重新上传';
                    } else if (descFailed) {
                        toastMessage = '项目描述不符合平台的发布规范，请修改后重新上传';
                    }
                    if (toastMessage) {
                        swal2.toast(toastMessage);
                    }
                    return;
                }

            } catch (error) {
                if (axiosLib.isCancel && axiosLib.isCancel(error)) {
                    return;
                }
                console.error('文本检查失败:', error);
                swal2.toast('文本检查失败，请重试');
                return;
            }

            // 文本检查通过后，进行视频内容审核
            const userinfo = getUserinfo() || {};
            const {id: authorId, realName: authorName} = userinfo;
            const {role, studentId} = queryParams;
            // 这里假设 blob 中已经包含 url、md5 信息；如果实际结构不同，请按实际字段替换
            const {videoUrl, videoMd5} = this.props || {};
            const videoParams = {
                type: 3,
                url: videoUrl,
                md5: videoMd5,
                module: 3,
                authorId: studentId || authorId || '',
                authorName: authorName || '',
                role,
                businessId: videoMd5
            };

            const videoCheckResult = await this.pollVideoCheck(videoParams);
            const videoFailed = !videoCheckResult.passed;

            // 视频检查失败，直接返回
            if (videoFailed) {
                swal2.toast('视频包含不当内容，请修改后重新上传');
                return;
            }


            this.setState({
                shareStatus: 'videoUpload',
                payload
            });
        }  else {
            // 先进行文本检查
            const {shareTitle, shareDes} = payload;
            const projectName = shareTitle || '';
            const projectDesc = shareDes || '';
            
            const nameCancelToken = axiosLib.CancelToken.source();
            const descCancelToken = axiosLib.CancelToken.source();
            this.cancelTokens.push(nameCancelToken.cancel, descCancelToken.cancel);
            
            try {
                const [nameCheckResult, descCheckResult] = await Promise.all([
                    textCheck({ url: projectName, module: 6 }, nameCancelToken.token),
                    textCheck({ url: projectDesc, module: 6 }, descCancelToken.token)
                ]);
                
                const nameStatus = nameCheckResult?.data?.data?.status;
                const descStatus = descCheckResult?.data?.data?.status;
                
                if (nameStatus === 4 && descStatus === 4) {
                    swal2.toast('项目名称和描述不符合平台的发布规范，请修改后重新上传');
                    return;
                } 
                if (nameStatus === 4) {
                    swal2.toast('项目名称不符合平台的发布规范，请修改后重新上传');
                    return;
                }
                if (descStatus === 4) {
                    swal2.toast('项目描述不符合平台的发布规范，请修改后重新上传');
                    return;
                }
                if (nameStatus === 5 ||descStatus === 5) {
                    swal2.toast('重复提交');
                    return;
                }
                
                // 只有当两个 status 都是 3 时，才继续执行
                if (nameStatus !== 3 && descStatus !== 3) {
                    return;
                }
                
                // 文本检查通过，继续执行
                this.handleNextStep(payload);
            } catch (error) {
                if (axiosLib.isCancel && axiosLib.isCancel(error)) {
                    return;
                }
                console.error('文本检查失败:', error);
                swal2.toast('文本检查失败，请重试');
            }
        }
    }

    handleUploadError () {
        this.setState({
            shareStatus: 'firstStep'
        }, () => {
            swal.swal({
                title: '视频上传失败了',
                text: '',
                icon: 'error',
                buttons: ['关闭', '重试'],
                closeOnClickOutside: false
            }).then(isConfirm => {
                if (isConfirm) {
                    this.handleStep(this.state.payload);
                } else {
                    // _this.props.onCloseModal();
                }
            });
        });
    }
    handleSecondStep (videoId) {
        const {payload} = this.state;
        this.setState({
            videoId
        }, () => {
            this.handleNextStep(payload);
        });
    }
    handleNextStep (payload) {
        const {
            shareTitle: exerciseName,
            shareDes: description,
            isPublish,
            tags
        } = payload;
        const {
            reduxProjectId: exerciseId
        } = this.props;
        const {
            // cityCode,
            videoId
        } = this.state;
        // 设置临时分享参数
        this.shareParamsForShareProj = {
            payload,
            cityCode: getCityCode(),
            isPublish,
            exerciseId,
            description,
            exerciseName
        };
        try {
            const callback = res => {
                const {status, data} = res;
                if (status === 200) {
                    let shareId;
                    if (videoId) {
                        shareId = videoId;
                        if (data.data.pointToast) swal2.toast(data.data.pointToast);
                    } else {
                        shareId = data.data.shareId;
                    }
                    this.setState({
                        shareId,
                        shareStatus: 'secondStep'
                    }, () => {
                        scratchView('view_xiaohou_share_step5', {
                            language: 'Scratch',
                            editor: 'Scratch编辑器',
                            scene: '社区创作',
                            bundle_id: '',
                            question_id: '',
                            content_type: videoId ? '视频作品' : '纯项目作品'
                        });
                        if (isPublish) {
                            this.shareParams = payload;
                            this.publishCommunity(exerciseName, description, tags);
                        }
                    });
                }
            };
            let shareVideo = () => {};
            const _this = this;
            const errorback = () => {
                swal.swal({
                    title: '二维码生成失败了',
                    text: '',
                    icon: 'error',
                    buttons: ['关闭', '重试'],
                    closeOnClickOutside: false
                }).then(isConfirm => {
                    if (isConfirm) {
                        shareVideo();
                    } else {
                        // 关闭弹框时清空 Redux 中暂存的标题和描述
                        if (_this.props.clearShareSavedInfo && typeof _this.props.clearShareSavedInfo === 'function') {
                            _this.props.clearShareSavedInfo();
                        }
                        _this.props.onCloseModal();
                    }
                });
            };
            shareVideo = () => {
                shareVideoPro({
                    authorType: 3, // 1.老师创作，2.学生创作, 3.社区
                    projectDesc: description,
                    projectId: exerciseId,
                    projectName: exerciseName,
                    projectType: 2,
                    videoId
                }).then(callback)
                    .catch(errorback);
            };
            if (videoId) {
                shareVideo();
            } else {
                this.publishCommunity(exerciseName, description, tags);
                // shareProj({
                //     exerciseId,
                //     exerciseName,
                //     description,
                //     cityCode,
                //     role: 3,
                //     category: 2
                // }).then(callback)
                //     .catch(error => {
                //         console.log(error);
                //         // this.props.onCloseModal();
                //         swal.error('二维码生成失败了');
                //     });
            }
            
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('error:', error);
        }
    }

    handleShareProj (communityWorkId) {
        try {
            const {
                payload,
                // cityCode,
                isPublish,
                exerciseId,
                description,
                exerciseName
            } = this.shareParamsForShareProj;

            const callback = res => {
                const {status, data} = res;
                if (status === 200) {
                    const shareId = data.data.shareId;
                    this.setState({
                        shareId,
                        shareStatus: 'secondStep'
                    }, () => {
                        scratchView('view_xiaohou_share_step5', {
                            language: 'Scratch',
                            editor: 'Scratch编辑器',
                            scene: '社区创作',
                            bundle_id: '',
                            question_id: '',
                            content_type: '纯项目作品'
                        });
                        if (isPublish) {
                            this.shareParams = payload;
                        }
                    });
                }
            };
            
            shareProj({
                role: 3,
                category: 2,
                cityCode: getCityCode(),
                exerciseId,
                description,
                exerciseName,
                communityWorkId
            }).then(callback)
                .catch(error => {
                    console.log(error);
                    swal.error('二维码生成失败了');
                });
        } catch (error) {
            console.log('分享出错', error);
        }
    }

    handleShare () {
        this.setState({
            shareStatus: 'firstStep'
        });
    }

    handleSaveTab (tab) {
        this.setState({
            selectedTab: tab
        });
    }

    resetShareStatus(savedTitle, savedDesc) {
        // 如果是从录制分享流程进入，并且父组件希望回到 GUI 层的 ShareModal（gui.jsx 190-197），
        // 则优先调用回调，由父组件（MediaRecordModal / MenuBar / GUI）控制重新打开最外层 ShareModal
        if (this.props.onReopenGuiShareModal && typeof this.props.onReopenGuiShareModal === 'function') {
            // 存储标题和描述到 Redux
            if (this.props.setShareSavedInfo && typeof this.props.setShareSavedInfo === 'function') {
                this.props.setShareSavedInfo(savedTitle, savedDesc, '视频录制');
            }
            // 打开 GUI 层的 ShareModal
            this.props.onReopenGuiShareModal();
      
            return;
        }

        // 默认行为：仅在当前 ShareModal 内部重置为“视频录制”初始状态
        this.setState({
            shareStatus: 'init',
            selectedTab: '视频录制',
        });
        // 清空 blob，以便重新录制
        if (this.props.onClearBlob) {
            this.props.onClearBlob();
        }
    }

    cancelAllRequests() {
        this.cancelTokens.forEach(cancel => {
            try {
                cancel('用户取消操作');
            } catch (error) {
            }
        });
        this.cancelTokens = [];

        if (this.pollVideoCheckCancel) {
            this.pollVideoCheckCancel();
            this.pollVideoCheckCancel = null;
        }
    }

    handleRecord (param) {
        this.props.onRecord(param);
    }
    handleRetryPublishCommunity () {
        const {
            shareTitle: exerciseName,
            shareDes: description,
            tags
        } = this.shareParams;
        this.publishCommunity(exerciseName, description, tags);
    }
    /**
     * 发布社区
     * @param {string} name 项目名称
     * @param {string} description 项目描述
     * @param {array} tags 标签
     */
    publishCommunity (name, description, tags) {
        const {original_id, thumbnailPath} = this.props;
        const communityShare = {
            tags,
            classId: '-',
            lessonId: '-',
            category: 2,
            originId: original_id,
            communityWorksCreateArea: 1,
            publishDto: {
                name,
                description,
                thumbnail: thumbnailPath,
                version: '3.0',
                xml: this.props.vm.toJSON(),
                type: 8
            }
        };

        this.setState({
            publishState: 'publishing'
        });
  
        const errorback = () => {
            this.setState({
                publishState: 'error'
            });
            // setTimeout(() => {
            //   this.publishState = 'error';
            // }, 1000);
        };
  
        const callback = res => {
            const {status, data} = res;
            if (status === 200) {
                this.handleShareProj(data.data);
                this.setState({
                    publishState: 'published'
                });
            } else {
                errorback();
            }
        };
        const userType = localStorage.getItem('XIAOHOUCODE_TEACHERTYPE');
        communityShare.userType = userType && Number(userType);
        communityPublish(communityShare).then(callback)
            .catch(errorback);
    }
    render () {
        const {
            thumbnail,
            shareStatus,
            selectedTab,
            // cityCode,
            shareId,
            videoId,
            publishState,
            isVideoPointUpLimit,
            singleVideoPoint,
            videoCheckStatus
        } = this.state;
        const {
            role
        } = queryParams;
        const {
            onCloseModal,
            reduxProjectId,
            reduxProjectTitle,
            onVideo,
            onAudio,
            blob,
            mediaRecorder,
            volume,
            record,
            duration,
            onSetRecordState,
            videoType,
            audioType,
            onCloseMediaModal,
            setSaveTab
        } = this.props;

        return (
            <div>
                { shareStatus === 'init' && <MediaModal
                    onAudio={onAudio}
                    onCloseModal={(isClose) => {
                        if (this.props.clearShareSavedInfo && typeof this.props.clearShareSavedInfo === 'function' && isClose) {
                            this.props.clearShareSavedInfo();
                        }
                        if(onCloseMediaModal) onCloseMediaModal();
                        if(onCloseModal) onCloseModal();
                    }}
                    onRecord={this.handleRecord}
                    onShare={this.handleShare}
                    onVideo={onVideo}
                    selectedTab={selectedTab}
                    singleVideoPoint={singleVideoPoint}
                    savedTab={this.props.savedTab}
                    onSaveTab={setSaveTab}
                />}
                { shareStatus === 'deviceDetectionStep' && <DeviceDetection
                    onCloseModal={onCloseModal}
                    mediaRecorder={mediaRecorder}
                    volume={volume}
                    record={record}
                    onSetRecordState={onSetRecordState}
                />}
                { shareStatus === 'firstStep' && <FirstStep
                    blob={blob}
                    defaultTitle={reduxProjectTitle}
                    savedProjectTitle={this.props.savedTitle}
                    savedProjectDesc={this.props.savedDesc}
                    thumbnail={thumbnail}
                    onClick={this.handleStep}
                    onCloseModal={() => {
                        this.cancelAllRequests();
                        // 关闭弹框时清空 Redux 中暂存的标题和描述
                        if (this.props.clearShareSavedInfo && typeof this.props.clearShareSavedInfo === 'function') {
                            this.props.clearShareSavedInfo();
                        }
                        onCloseModal();
                    }}
                    onResetShareStatus={this.resetShareStatus}
                    isVideoPointUpLimit={isVideoPointUpLimit}
                    singleVideoPoint={singleVideoPoint}
                    videoType={videoType}
                    audioType={audioType}
                    duration={duration}
                    isVideoChecking={videoCheckStatus === 1 || videoCheckStatus === 2}
                    onSaveTab={setSaveTab}
                />}
                { shareStatus === 'secondStep' && <SecondStep
                    cityCode={getCityCode()}
                    publishState={publishState}
                    reduxProjectId={reduxProjectId}
                    role={role}
                    shareId={shareId}
                    thumbnail={thumbnail}
                    videoId={videoId}
                    onCloseModal={onCloseModal}
                    onPublishCommunity={this.handleRetryPublishCommunity}
                />}
                { shareStatus === 'videoUpload' && <UploadVideo
                    blob={blob}
                    onClick={this.handleSecondStep}
                    onCloseModal={onCloseModal}
                    onError={this.handleUploadError}
                />}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    original_id: state.scratchGui.projectState.original_id,
    thumbnailPath: state.scratchGui.projectState.thumbnailPath,
    savedTitle: state.scratchGui.projectState.savedShareTitle,
    savedDesc: state.scratchGui.projectState.savedShareDesc,
    savedTab: state.scratchGui.projectState.savedShareTab
});


ShareModal.propTypes = {
    onAudio: PropTypes.func,
    onCloseModal: PropTypes.func,
    onCloseMediaModal: PropTypes.func,
    onRecord: PropTypes.func,
    onVideo: PropTypes.func,
    onClearBlob: PropTypes.func,
    onReopenGuiShareModal: PropTypes.func,
    setShareSavedInfo: PropTypes.func,
    clearShareSavedInfo: PropTypes.func,
    // blob: PropTypes.oneOfType([PropTypes.blob, PropTypes.undefined]),
    reduxProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reduxProjectTitle: PropTypes.string,
    thumbnailPath: PropTypes.string,
    original_id: PropTypes.string,
    vm: PropTypes.instanceOf(VM),
    // eslint-disable-next-line react/forbid-prop-types
    mediaRecorder: PropTypes.any,
    volume: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    record: PropTypes.object,
    onSetRecordState: PropTypes.func,
    videoType: PropTypes.bool,
    audioType: PropTypes.bool,
    duration: PropTypes.number
};

export default injectIntl(connect(
    mapStateToProps
)(ShareModal));
